import {QueryObserverSuccessResult, UseQueryResult} from "@tanstack/react-query";
import {AxiosError} from "axios";
import React, {ReactNode} from "react";
import {FullPageLoader} from "../../components/full-page-loader";
import {Alert} from "antd";

export type Error = AxiosError<{
  status: boolean;
  message: string;
}>;

interface HandleQueryProps<TData, TError> {
  query: UseQueryResult<TData, TError>;
  children: (data: QueryObserverSuccessResult<TData, TError>) => ReactNode;
  loader?: ReactNode;
  errorView?: (err: TError) => ReactNode;
}

export function HandleQuery<TData, TError extends Error>({
  query,
  children,
  loader = <FullPageLoader />,
  errorView = (err) => (
    <Alert message="Error" description={err.message} type="error" showIcon />
  ),
}: HandleQueryProps<TData, TError>) {
  if (query.isLoading) {
    return <>{loader}</>;
  }

  if (query.isError) {
    return <>{errorView(query.error)}</>;
  }
  return <div>{children(query)}</div>;
}
